var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('el-dialog',{attrs:{"visible":_vm.dialogFormVisible,"before-close":_vm.handleClose,"width":_vm.$isMobile ? '350px' : '500px'},on:{"update:visible":function($event){_vm.dialogFormVisible=$event}}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.info.content)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }